export default __webpack_public_path__ + "static/media/remingtonSketch@2x.aa3a8439.jpg";